import {
  ChangeDetectionStrategy,
  Component,
  output,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublicCheckoutFormComponent } from '../public-checkout-form/public-checkout-form.component';
import {
  PublicCartDetails,
  PublicCartItem,
  PublicCartService,
} from '@web/shared/module/shop';
import { combineLatest, Observable } from 'rxjs';
import { PublicOrderCheckoutSummaryComponent } from '../../components/public-order-checkout-summary/public-order-checkout-summary.component';
import { isEmptyArray, isNotNil, Nillable, valueOrDefault } from '@web/utils';
import { PublicDiscountCodeSubmitEvent } from '../../events/public-discount-code-submit.event';
import { SpinnerFilledComponent, WithLoadingPipe } from '@web/shared/ui';
import { PublicCartEmptyComponent } from '../public-cart-empty/public-cart-empty.component';
import { PublicCheckoutSubmitSuccessEvent } from '../../events/public-checkout-submit-success.event';

@Component({
  selector: 'app-public-checkout',
  imports: [
    CommonModule,
    PublicCheckoutFormComponent,
    PublicOrderCheckoutSummaryComponent,
    SpinnerFilledComponent,
    WithLoadingPipe,
    PublicCartEmptyComponent,
  ],
  templateUrl: './public-checkout.component.html',
  styleUrl: './public-checkout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicCheckoutComponent {
  private readonly cart = inject(PublicCartService);

  /* prettier-ignore */
  public readonly checkoutSuccessEvent = output<PublicCheckoutSubmitSuccessEvent>();

  protected readonly checkoutSummary$: Observable<{
    items: PublicCartItem[];
    details: Nillable<PublicCartDetails>;
  }>;

  protected readonly valueOrDefault = valueOrDefault;
  protected readonly isEmptyArray = isEmptyArray;

  public constructor() {
    this.checkoutSummary$ = combineLatest({
      items: this.cart.items$,
      details: this.cart.details$,
    });
  }

  public handleSubmitEvent(event: PublicCheckoutSubmitSuccessEvent): void {
    this.checkoutSuccessEvent.emit(event);
  }

  public handleDiscountCodeSubmitEvent(
    event: PublicDiscountCodeSubmitEvent,
  ): void {
    const { discountCode } = event;

    console.log(`Try to apply the "${discountCode}".`);
  }

  public isNotEmpty<T>(items: Nillable<T[]>): items is T[] {
    return isNotNil(items) && !isEmptyArray(items);
  }
}
